export default __webpack_public_path__ + "static/media/download-sat-report.d8218d63.svg";